import React from "react";
import SkeletonAnimation from "../Skeleton/BasicSkeleton/SkeletonAnimation";
import SkeletonElement from "../Skeleton/BasicSkeleton/SkeletonElement";
import SkeletonCard from "../Skeleton/BasicSkeleton/SkeletonCard";

const LeaderBoardSkeleton = () => {
  return (
    <div className="leader-board-skeleton">
      <div className="skeleton-card large back">
        <SkeletonElement type="title" />
        <SkeletonAnimation />
      </div>
      <div className="Leaderboard-hero leaderboard-popular mx-auto">
        <div className="gangsta-card-container p-4">
          <SkeletonCard className="m-0" />
          <SkeletonCard className="m-0" />
          <SkeletonCard className="m-0" />
          <SkeletonCard className="m-0" />
          <SkeletonCard className="m-0 d-none d-md-block" />
          <SkeletonCard className="m-0 d-none d-md-block" />
          <SkeletonCard className="m-0 d-none d-md-block" />
        </div>
      </div>

      <div className="py-4">
        <div className="class-type-container">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center top-container my-3">
            <div className="skeleton-card large w-lg-25 p-2">
              <SkeletonElement type="title" />
              <SkeletonElement type="text" />
              <SkeletonAnimation />
            </div>
            <div className="d-flex justify-content-lg-end mt-3 mt-lg-0 w-lg-50 flex-wrap skeleton-card large p-2">
              <SkeletonElement type="button mx-2 my-1" />
              <SkeletonElement type="button mx-2 my-1" />
              <SkeletonElement type="button mx-2 my-1" />
              <SkeletonAnimation />
            </div>
          </div>
          <div className="gangsta-card-container">
            <SkeletonCard className="m-0" />
            <SkeletonCard className="m-0" />
            <SkeletonCard className="m-0" />
            <SkeletonCard className="m-0" />
            <SkeletonCard className="m-0" />
            <SkeletonCard className="m-0 d-none d-md-block" />
            <SkeletonCard className="m-0 d-none d-md-block" />
            <SkeletonCard className="m-0 d-none d-md-block" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderBoardSkeleton;
